import React, { useState } from 'react';

function SurveyStepTen({ formData, onNext }) {
    const [learningSuggestions, setLearningSuggestions] = useState(formData.learningSuggestions || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!learningSuggestions.trim()) {
            setError('Please share your thoughts before continuing.');
            return;
        }
        setError('');
        onNext({ learningSuggestions });
    };

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 2: Career Development</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                What learning and development opportunities would you like the organization to offer to support your career goals? <span className="text-danger">*</span>
            </label>

            <textarea
                className="form-control"
                rows="6"
                value={learningSuggestions}
                onChange={(e) => setLearningSuggestions(e.target.value)}
                placeholder="Please share your thoughts here..."
            />

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!learningSuggestions.trim()}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTen;
